
import { ProductGroup } from "@/types/product";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface SelectedProductsSectionProps {
  selectedInterests: string[];
  productGroups: ProductGroup[];
}

const SelectedProductsSection = ({ 
  selectedInterests, 
  productGroups 
}: SelectedProductsSectionProps) => {
  if (selectedInterests.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 mt-6 border p-4 rounded-lg bg-slate-50">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-lg">Selected Product Categories</h3>
        <Badge variant="outline" className="bg-white">
          {selectedInterests.length} selected
        </Badge>
      </div>
      
      <p className="text-sm text-muted-foreground mb-4">
        You've selected the following product categories for pricing information:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {selectedInterests.map((interestId) => {
          const group = productGroups.find((g) => g.id === interestId);
          if (!group) return null;
          
          return (
            <Card key={group.id} className="p-4 border border-muted hover:shadow-md transition-shadow">
              <div className="flex flex-col space-y-2">
                <h4 className="font-medium text-[#069E50]">{group.name}</h4>
                <p className="text-sm text-muted-foreground">{group.description}</p>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedProductsSection;
